export default "__VITE_ASSET__CNG4umB9__"